import React, { useState } from "react";
import "./otp.css";
import Interra from "../images/logo.png";
import Illustration from "../images/illustrationLog.png";
import { useNavigate } from 'react-router-dom';
import { recaptaSetup } from '../firebase'

function Otp() {

  const navi = useNavigate();

  const [confirmObj, setConfirmObj] = useState({});
  // const [email, setEmail] = useState("")

  const getOTP = async (e) => {


    e.preventDefault();
    let phone = localStorage.getItem("Phone", phone);
    if (phone === "" || phone === undefined) {
      alert("Please Enter Phone Number");
      navi("/login");
    }
    else {
      try {
        recaptaSetup(phone)
          .then((res) => {
            console.log(res);
            setConfirmObj(res);
            window.res = res;
          })
        // console.log(response);
        // setConfirmObj(response);
      } catch (error) {
        alert(error.message);
        console.log(error.message);
      }
    }
  }
  function ClickLogo(){
    let path = `/`; 
    navi(path);
}

  const handleSubmit = async () => {

    let OTP = one + two + three + four;
    console.log("heree-->", OTP)


    if (localStorage.getItem("phone") === "" || localStorage.getItem("phone") === undefined) {
      alert("Please Enter Phone Number");
      navi("/login");
      return;
    }
    try {
      await confirmObj.confirm(OTP)
      navi("/view-influencer");
    } catch (error) {
      alert(error.message);
      console.log(error.message);
      navi("/otp");
    }

  }



  const [userOTP, setuserOTP] = useState("");
  const [one, setOne] = useState("");
  const [two, setTwo] = useState("");
  const [three, setThree] = useState("");
  const [four, setFour] = useState("");
  const [five, setFive] = useState("");
  const [six, setSix] = useState("");

  // const handleInputChange = (e) => {
  //   const { id, value } = e.target;
  //   if (id === "one") {
  //     setOne(value);
  //   }
  //   if (id === "two") {
  //     setTwo(value);
  //   }
  //   if (id === "three") {
  //     setThree(value);
  //   }
  //   if (id === "four") {
  //     setFour(value);
  //   }
  // }




  return (
    <div className="outer">
      <img src={Interra} className="logo1" onClick={ClickLogo}></img>
      <div className="box1">
        <div class="columns">
          <div class="column">
            <div className="login">
              Please enter the 6 digit code sent to you
            </div>
            <div className="row12">
              <div className="col6">
                <input type="text" className="otp-field" value={one} maxLength='1' onChange={(e) => setOne(e.target.value)} />
              </div>
              <div className="col6">
                <input type="text" className="otp-field" value={two} maxLength='1' onChange={(e) => setTwo(e.target.value)} />
              </div>
              <div className="col6">
                <input type="text" className="otp-field" value={three} maxLength='1' onChange={(e) => setThree(e.target.value)} />
              </div>
              <div className="col6">
                <input type="text" className="otp-field" value={four} maxLength='1' onChange={(e) => setFour(e.target.value)} />
              </div>
              <div className="col6">
                <input type="text" className="otp-field" value={five} maxLength='1' onChange={(e) => setFive(e.target.value)} />
              </div>
              <div className="col6">
                <input type="text" className="otp-field" value={six} maxLength='1' onChange={(e) => setSix(e.target.value)} />
              </div>
            </div>

            <div className="remember1">
              <input type="radio" className="check"></input>  Resend the Verification Code
            </div>

            <div className="loginButton1">
              <button onClick={getOTP} type="submit" className="cont">
                Get OTP
              </button>
              <button onClick={handleSubmit} type="submit" className="cont">
                Verify OTP
              </button>
              <div id='recaptcha-container'>

              </div>
            </div>

          </div>

          <div class="column">
            <img src={Illustration} className="illl1"></img>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Otp;
